
export type SearchHashtags200HashtagsItem = {
  id?: string;
  name?: string;
  tweetCount?: number;
};
